(() => {
  if (window.predictiveSearchLoader) return;

  const loader = document.currentScript;
  const predictiveSearchSrc = loader.dataset.predictiveSearchSrc;
  const tabsSrc = loader.dataset.tabsSrc;
  let loadPromise;

  const loadScript = (src) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  const removeIntentListeners = () => {
    document.removeEventListener('focusin', handleIntent, true);
    document.removeEventListener('pointerdown', handleIntent, true);
    document.removeEventListener('keydown', handleIntent, true);
  };

  const loadPredictiveSearch = (searchElement) => {
    if (!loadPromise) {
      removeIntentListeners();
      loadPromise = Promise.all([
        loadScript(tabsSrc),
        loadScript(predictiveSearchSrc)
      ]).then(() => {
        // The event that triggered loading may have completed before the custom
        // element upgraded, so replay the current query once it is ready.
        const input = searchElement.querySelector('.js-search-input');
        if (input === document.activeElement && input.value.trim()) {
          searchElement.handleFocus();
        }
      }).catch((error) => {
        console.error('Unable to load predictive search.', error);
      });
    }

    return loadPromise;
  };

  function handleIntent(event) {
    const searchElement = event.target.closest('predictive-search');
    if (searchElement) loadPredictiveSearch(searchElement);
  }

  window.predictiveSearchLoader = { load: loadPredictiveSearch };
  document.addEventListener('focusin', handleIntent, true);
  document.addEventListener('pointerdown', handleIntent, true);
  document.addEventListener('keydown', handleIntent, true);
})();
